module.exports = __webpack_public_path__ + "img/twitter-icon.abfbd4d9.svg";